import { render } from "./pagoWebAprobado.vue?vue&type=template&id=0f4e39e3"
import script from "./pagoWebAprobado.vue?vue&type=script&lang=js"
export * from "./pagoWebAprobado.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__